var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44511 12C6.26841 11.9992 6.09899 11.9253 5.97299 11.7941L2.86255 8.50054C2.73734 8.36795 2.66699 8.18812 2.66699 8.00061C2.66699 7.8131 2.73734 7.63328 2.86255 7.50069C2.98776 7.3681 3.15759 7.29361 3.33467 7.29361C3.51175 7.29361 3.68158 7.3681 3.80679 7.50069L6.44511 10.2944L12.1939 4.20708C12.2559 4.14142 12.3295 4.08935 12.4105 4.05382C12.4915 4.01829 12.5783 4 12.666 4C12.7537 4 12.8405 4.01829 12.9215 4.05382C13.0025 4.08935 13.0761 4.14142 13.1381 4.20708C13.2001 4.27273 13.2493 4.35067 13.2828 4.43644C13.3164 4.52222 13.3337 4.61415 13.3337 4.707C13.3337 4.79984 13.3164 4.89178 13.2828 4.97756C13.2493 5.06333 13.2001 5.14127 13.1381 5.20692L6.91723 11.7941C6.79122 11.9253 6.62181 11.9992 6.44511 12Z",
    fill: "#14782E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.0453786b7fd815f6f51eedaa30b6e67a.svg";
export { ForwardRef as ReactComponent };